export const PERIODS = [
  { id: "today", label: "Today" },
  { id: "week", label: "This week" },
  { id: "month", label: "This month" },
  { id: "quarter", label: "This quarter" },
  { id: "year", label: "This year" },
  { id: "custom", label: "Custom" },
];

export function localToday() {
  const now = new Date();
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
}

function shiftDate(stamp, days) {
  const date = new Date(`${stamp}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function rangeFor(period, fromDate, toDate) {
  const today = localToday();
  if (period === "today") return { fromDate: today, toDate: today };
  if (period === "week") {
    const date = new Date(`${today}T00:00:00Z`);
    const weekday = date.getUTCDay();
    const mondayOffset = weekday === 0 ? 6 : weekday - 1;
    return { fromDate: shiftDate(today, -mondayOffset), toDate: today };
  }
  if (period === "month") return { fromDate: `${today.slice(0, 8)}01`, toDate: today };
  if (period === "quarter") {
    const month = Number(today.slice(5, 7));
    const quarterMonth = Math.floor((month - 1) / 3) * 3 + 1;
    return { fromDate: `${today.slice(0, 5)}${String(quarterMonth).padStart(2, "0")}-01`, toDate: today };
  }
  if (period === "year") return { fromDate: `${today.slice(0, 4)}-01-01`, toDate: today };
  const from = fromDate || today;
  return { fromDate: from, toDate: toDate || from };
}
